import React from 'react';
import { Tooltip } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tooltipStyle: {
    // width: 200,
    // margin:0,
    padding:0,
    background:"#000000",
    border: "1px solid #000000",
    borderRadius:4,
    boxShadow: "0px 4px 8px 0px rgba(96, 104, 112, 0.16), 0px 0px 2px 0px rgba(40, 51, 61, 0.04)"
  },
  arrowStyle:{
    color:"#000000",
    fontSize:20
  }
}));

const TooltipMat = (props) =>{
  const classes = useStyles();
    return (
      <Tooltip 
       classes={{ tooltip: classes.tooltipStyle , arrow:classes.arrowStyle}}
       placement="top"
       arrow
       title={<>
        <div style={{
          // padding:5,
          marginLeft:10,
          marginRight:10
        }}>
          {props.title}
        </div>
      </>} >
        <span style={{
          position: "absolute",
          paddingTop: 4
        }}>
          {props.data}
        </span>
      </Tooltip>

    )
}

export default TooltipMat; 